import { v4 as uuidv4 } from "uuid";

const dataSlider = [
	{
		id: uuidv4(),
		title: "Lorem ipsum",
		subTitle: "Lorem",
		img: require("./GalerySliderImage/1.jpg"),
		alt: "img1",
	},
	{
		id: uuidv4(),
		title: "Lorem ipsum",
		subTitle: "Lorem",
		img: require("./GalerySliderImage/2.jpg"),
		alt: "img2",
	},
	{
		id: uuidv4(),
		title: "Lorem ipsum",
		subTitle: "Lorem",
		img: require("./GalerySliderImage/3.jpg"),
		alt: "img3",
	},
	{
		id: uuidv4(),
		title: "Lorem ipsum",
		subTitle: "Lorem",
		img: require("./GalerySliderImage/4.jpg"),
		alt: "img4",
	},
	{
		id: uuidv4(),
		title: "Lorem ipsum",
		subTitle: "Lorem",
		img: require("./GalerySliderImage/5.jpg"),
		alt: "img5",
	},
	{
		id: uuidv4(),
		title: "Lorem ipsum",
		subTitle: "Lorem",
		img: require("./GalerySliderImage/6.jpg"),
		alt: "img6",
	},
	{
		id: uuidv4(),
		title: "Lorem ipsum",
		subTitle: "Lorem",
		img: require("./GalerySliderImage/7.jpg"),
		alt: "img7",
	},
	{
		id: uuidv4(),
		title: "Lorem ipsum",
		subTitle: "Lorem",
		img: require("./GalerySliderImage/8.jpg"),
		alt: "img8",
	},
];

export default dataSlider;
